<template>
  <div class="members-count">
    <MDBBadge pill class="assignees-count" :class="{ 'no-assigned': selectedProject.assigneesCount === 0 }">{{ selectedProject.assigneesCount }}</MDBBadge>
    <span>Members</span>
  </div>
</template>
<style lang="scss" scoped>
.members-count {
  display: flex;
  align-items: center;
  padding: 16px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: $neutral-800;
  border-block: 1px solid $neutral-40;
  .assignees-count {
    margin-right: 8px;
    background-color: $purple-300;

    &.no-assigned {
      background-color: $neutral-40;
    }
  }
}
</style>
<script>
import { MDBBadge } from 'mdb-vue-ui-kit';
import { storeToRefs } from 'pinia';
import { useProjectTaggingStore } from '../../../../stores/projectTagging';
export default {
  name: 'ProjectTaggingViewProjectMembersCount',
  components: {
    MDBBadge,
  },
  setup() {
    const projectTaggingStore = useProjectTaggingStore();
    const { selectedProject } = storeToRefs(projectTaggingStore);
    return {
      selectedProject,
    };
  },
};
</script>
